"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function ViewAllButton() {
    const router = useRouter();
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={()=> router.push("/product")} // ← chuyển hướng đến trang collection
      style={{
        background: hovered ? "#4a5e3a" : "transparent",
        border: "1.5px solid #4a5e3a",
        color: hovered ? "#ffffff" : "#4a5e3a",
        fontFamily: "'Lato', sans-serif",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.18em",
        padding: "14px 40px",
        borderRadius: 4,
        cursor: "pointer",
        transition: "background 0.2s, color 0.2s",
      }}
    >
      XEM TẤT CẢ SẢN PHẨM »
    </button>
  );
}
